import { reelsAvgTimeWatchedConfig } from '@/lib/analytics/kpis/instagram/reels/reelsAvgTimeWatched';
import { SIZE_50 } from '@/lib/gridElements/size';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const reelsAvgTimeWatchedMVConfig: KpiType<
    typeof MediaViewerKpiLoader,
    typeof MediaViewerKPI
> = {
    ...reelsAvgTimeWatchedConfig,
    id: 'average_time_watched',
    size: SIZE_50,
    orientation: ORIENTATION_VERTICAL,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
